import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import APIOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/api.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  APIOverrideServerProperties,
  React
};